import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useIndicators } from "hooks/indicatorHooks";

import { LayerProperties } from "types";

interface Props {
  config: string;
  search: string;
  selected: string[];
  layerProperties: LayerProperties[];
}

export function TagsLayerCount(props: Props) {
  const { config, search, selected, layerProperties } = props;
  const { t } = useTranslation();
  const { data: layers } = useIndicators(
    config,
    {
      tags: selected,
      limit: 1,
      offset: 0,
      search,
    },
    layerProperties
  );

  return (
    <>
      {layers && (
        <Typography variant="body1" marginLeft="auto!important" paddingTop={1}>
          {t("label.numCards", { count: layers.totalCount })}
        </Typography>
      )}
    </>
  );
}
